import React from "react";

import { Header } from "../../components/headers/header/header.component";

export const ExecutionBriefListHeader = () => {
  return <Header title="Multi Channel Briefs" />;
};
